import loadable from '@loadable/component';
export const manifest = {
  ClosableBlock: {
    device: {
      desktop: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "ClosableBlockDesktop";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "ClosableBlockDesktop" */
          './src/widgets/block/desktop'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./src/widgets/block/desktop");
            }

            return eval('require.resolve')("./src/widgets/block/desktop");
          }

        }, {
          resolveComponent: m => m.ClosableBlockDesktop,
          ssr: false
        })
      },
      mobile: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "ClosableBlockMobile";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "ClosableBlockMobile" */
          './src/widgets/block/mobile'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./src/widgets/block/mobile");
            }

            return eval('require.resolve')("./src/widgets/block/mobile");
          }

        }, {
          resolveComponent: m => m.ClosableBlockMobile,
          ssr: false
        })
      }
    }
  },
  'ClosableBlock.CloseProvider': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "ClosableBlockCloseProvider";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "ClosableBlockCloseProvider" */
          './src/widgets/close-provider/index'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./src/widgets/close-provider/index");
            }

            return eval('require.resolve')("./src/widgets/close-provider/index");
          }

        }, {
          resolveComponent: m => m.ClosableBlockCloseProvider
        })
      }
    }
  }
};